import React from 'react';
import FeaturedWorks from '../components/FeaturedWorks.jsx';
import Availability from '../components/Availability.jsx';
import Blurb from '../components/Blurb.jsx';
import { getFeaturedEntries } from '../lib/featured.js';

export default function OtherDev() {
  const hasWorks = getFeaturedEntries('other-dev').length > 0;

  return (
    <>
      <h2 className="page-header">Other Dev</h2>
      <Blurb>
        <p>
          In a past life, I devoted my life to the arts - writing, drawing, creating other worlds.
          
          <br />
          The work below is a sample of that practice.
          <br />
          Most of it is incomplete passion projects that I open once in a while to work on.
        </p>
      </Blurb>
      <section>
        <p>
          Side projects that sit outside studio game work and fullstack products,
          including published webcomics and written works.
        </p>
        <ul className="styled-list">
          <li>Webnovels and webcomics published on Tapas</li>
          <li>Personal utilities, prototypes, and one-off builds</li>
        </ul>
      </section>

      {hasWorks ? (
        <FeaturedWorks category="other-dev" title="Featured Other Dev Works" layout="rows" />
      ) : (
        <section className="featured-works">
          <h2>Featured Other Dev Works</h2>
          <p className="gallery-hint">Mods, tools, and other side projects will appear here.</p>
        </section>
      )}

      <Availability />
    </>
  );
}
